
import { Tooltip } from "@fluentui/react-components";
import moment from "moment";
import React, { ReactElement } from "react";

type DateTimeDisplayUTCProps = {
    date: Date;
    hideTime?: boolean;
    dateFormat?: string;
    timeFormat?: string;
    multiline?: boolean;
}

export const DateTimeDisplayUTC: React.FC<DateTimeDisplayUTCProps> = (props) => {

    const dateFormat: string = props.dateFormat ? props.dateFormat : "DD.MM.YYYY";
    const timeFormat: string = props.timeFormat ? props.timeFormat : "HH:mm";
    let format = `${dateFormat}${props.hideTime ? "" : ` ${timeFormat}`}`;


    if (props.date) {
        if (!props.multiline) {
            return <Tooltip content={<DateTimeUtcTooltipContent date={props.date} format={format} />} relationship='description' withArrow positioning='after'>
                <span>{moment.utc(props.date).format(format)}</span>
            </Tooltip>;
        } else {
            return <Tooltip content={<DateTimeUtcTooltipContent date={props.date} format={format} />} relationship='description' withArrow positioning='after'>
                <span>{moment.utc(props.date).format(dateFormat)}
                    <br />{moment.utc(props.date).format(timeFormat)}  </span>
            </Tooltip>;
        }
    }
    return null;
}

type DateTimeUtcTooltipContentProps = {
    date: Date;
    format: string;
}

const DateTimeUtcTooltipContent: React.FC<DateTimeUtcTooltipContentProps> = (props) => {


    return <div style={{ display: "grid", gridTemplateColumns: "auto auto", columnGap: "5px" }}>

        <span>UTC:</span><span>{moment.utc(props.date).format(props.format)} </span>


        <span>Local:</span> <span>{moment(props.date).format(props.format)}</span>


    </div>
}